import React from "react";
import {clearUserToken} from '../controller/AuthService'
import history from '../controller/History'

export class Logout extends React.Component {

    componentDidMount() {
        clearUserToken();
        history.push('/')
    }

    render() {
        return (
            <div/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Logout.jsx